import { connectHook } from 'app/common/components/connect-hook';
import { EnumWidget } from './enum-widget';
import { useEnumWidget } from './enum-widget-hook';

export default connectHook(EnumWidget, useEnumWidget);
